import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { ModalCloseMethod } from '@rivethealth/data/analytics/account-analytics-events';
import { Loadable } from '../helpers/loadable';

@Component({
  selector: 'delete-form',
  styleUrls: ['./delete-form.component.scss'],
  templateUrl: './delete-form.component.html',
})
export class DeleteFormComponent {
  @Input()
  submitting: boolean = false;
  @Input()
  submitText: string = 'Delete';
  @Input()
  cancelText: string = 'Cancel';

  @Input() load: Loadable<any> | Loadable<any>[];
  @Input() loading = false;
  @Input() erred = false;

  @Input() backgroundShading = true;

  @Input() title: string;

  @Input() submit: () => Promise<void>;

  @Input() disableDelete: boolean = false;

  @Input() width: string | undefined;
  @Input() outerWidth: string | undefined;

  @Input() invertedColors = false;

  @Output() close = new EventEmitter<never>();
  @Output() submitted = new EventEmitter<never>();

  @HostListener('document:keydown', ['$event'])
  keyDown({ keyCode }: KeyboardEvent) {
    if (keyCode == 27) {
      this.close.emit();
    }
  }

  async formSubmit() {
    this.setCloseMethod(`Click ${this.submitText.toLowerCase()}`);
    this.submitted.emit();
    if (this.submit) {
      this.submitting = true;
      try {
        await this.submit();
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
        return;
      } finally {
        this.submitting = false;
      }
      this.close.emit();
    }
  }

  setCancelCloseMethod() {
    const cancelMethod: `Click ${string}` = `Click ${this.cancelText}`;
    this.setCloseMethod(cancelMethod);
  }

  closeMethodRef: { method: ModalCloseMethod } | undefined = undefined;
  setCloseMethod(method: ModalCloseMethod) {
    if (this.closeMethodRef) {
      this.closeMethodRef.method = method;
    }
  }
}
